import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import classnames from 'classnames';

const InputFormik = ({
  children,
  className,
  classNameContainer,
  field,
  fieldProps,
  form,
  id,
  label,
  placeholder,
  required,
  type,
}) => {
  const { errors, submitCount, touched } = form;
  let validationState = null;
  let errorText = null;

  if (touched[field.name] || submitCount > 0) {
    if (errors[field.name]) {
      validationState = 'danger';
      errorText = errors[field.name];
    } else {
      validationState = 'success';
    }
  }

  return (
    <FormGroup
      row
      color={validationState}
      className={classnames(classNameContainer, 'form-group-row')}
    >
      <Label for={id} className="form-group-row__label">
        {required ? (
          <span>
            {label} <span className="text-orange">*</span>
          </span>
        ) : (
          label
        )}
      </Label>
      <Input
        className={classnames(className, 'form-group-row__input')}
        id={id}
        type={type}
        placeholder={placeholder}
        {...field}
        {...fieldProps}
      />
      {children}
      <FormFeedback>{errorText}</FormFeedback>
    </FormGroup>
  );
};

InputFormik.propTypes = {
  children: PropTypes.shape({}),
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  field: PropTypes.shape({}),
  fieldProps: PropTypes.shape({}),
  form: PropTypes.shape({}),
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
};

InputFormik.defaultProps = {
  className: '',
  fieldProps: {},
  required: false,
  type: 'text',
};

export default InputFormik;
